export interface ExistingCommitteeLocation {
  hasExistingCommittee: boolean
}

export function isExistingCommitteeLocation(item: ExistingCommitteeLocation | unknown): item is ExistingCommitteeLocation {
  if (!item) {
    return false
  }
  if ((item as ExistingCommitteeLocation).hasExistingCommittee) {
    return true;
  }

  return false;
}

export interface NewBuyerCreatedLocation {
  newBuyerCreated: boolean
}

export function isNewBuyerCreatedLocation(item: NewBuyerCreatedLocation | unknown): item is NewBuyerCreatedLocation {
  if (!item) {
    return false
  }
  if ((item as NewBuyerCreatedLocation).newBuyerCreated) {
    return true;
  }

  return false;
}